import isNumber from 'lodash/isNumber';
import store from '@state/store';

export default {
  methods: {
    CurrencyConverter: (money) => {
      let currency = '৳';
      let user = store.getters['auth/currentUser'];
      if (user.country_id === 2) {
        currency = '₹';
      }
      if (!isNumber(money)) {
        return '-';
      }

      return money > 0 ? `${currency} ${money}` : money === 0 ? `${currency}0` : `- ${currency} ${-money}`;
    },
  },
};
